import { render } from "./price.vue?vue&type=template&id=3e6bf91b&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import "./price.vue?vue&type=style&index=0&id=3e6bf91b&scoped=true&lang=css"

import exportComponent from "/Users/cindy/mydoc/project/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6bf91b"]])

export default __exports__